import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";
import { post } from "@rails/request.js";
import { trackLead } from "../tracking";

export default class extends Controller {
  static values = {
    url: String,
    shouldTrackLead: { type: Boolean, default: false },
    contactEid: String,
    markTrackedUrl: String,
    leadSource: String,
    contactFormEid: String,
    contactFormName: String,
    promotionName: String,
    email: String,
    phoneE164: String,
  };

  connect() {
    const redirect = this.urlValue
      ? () => {
          window.top.location.href = this.urlValue;
        }
      : () => {};

    const cookieName = `contact_lead_tracked_${this.contactEidValue}`;
    const shouldTrack =
      this.shouldTrackLeadValue &&
      window.RINSED_TRACKING_IFRAME === true &&
      !Cookies.get(cookieName);

    if (shouldTrack) {
      const payload = {
        contact_eid: this.contactEidValue,
        lead_source: this.leadSourceValue,
        contact_form_eid: this.contactFormEidValue,
        contact_form_name: this.contactFormNameValue,
        promotion_name: this.promotionNameValue,
        user_data: {
          email: this.emailValue,
          phone_number: this.phoneE164Value,
        },
      };
      trackLead(payload, redirect);

      Cookies.set(cookieName, "1", {
        path: "/",
        expires: 30,
        sameSite: "Lax",
      });
      post(this.markTrackedUrlValue);
    } else if (this.urlValue) {
      this.timeoutId = setTimeout(redirect, 2000);
    }
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
}
